import a from"react";import{forwardRef as q,createElement as U}from"react";var B=t=>t.replace(/([a-z0-9])([A-Z])/g,"$1-$2").toLowerCase(),S=(...t)=>t.filter((u,o,l)=>!!u&&l.indexOf(u)===o).join(" ");import{forwardRef as T,createElement as F}from"react";var M={xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"};var D=T(({color:t="currentColor",size:u=24,strokeWidth:o=2,absoluteStrokeWidth:l,className:r="",children:f,iconNode:g,...w},k)=>F("svg",{ref:k,...M,width:u,height:u,stroke:t,strokeWidth:l?Number(o)*24/Number(u):o,className:S("lucide",r),...w},[...g.map(([P,A])=>F(P,A)),...Array.isArray(f)?f:[f]]));var e=(t,u)=>{let o=q(({className:l,...r},f)=>U(D,{ref:f,iconNode:u,className:S(`lucide-${B(t)}`,l),...r}));return o.displayName=`${t}`,o};var s=e("Heart",[["path",{d:"M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",key:"c3ymky"}]]);var i=e("ListMusic",[["path",{d:"M21 15V6",key:"h1cx4g"}],["path",{d:"M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",key:"8saifv"}],["path",{d:"M12 12H3",key:"18klou"}],["path",{d:"M16 6H3",key:"1wxfjs"}],["path",{d:"M12 18H3",key:"11ftsu"}]]);var c=e("Maximize2",[["polyline",{points:"15 3 21 3 21 9",key:"mznyad"}],["polyline",{points:"9 21 3 21 3 15",key:"1avn1i"}],["line",{x1:"21",x2:"14",y1:"3",y2:"10",key:"ota7mn"}],["line",{x1:"3",x2:"10",y1:"21",y2:"14",key:"1atl0r"}]]);var d=e("MicVocal",[["path",{d:"m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12",key:"80a601"}],["path",{d:"M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",key:"j0ngtp"}],["circle",{cx:"16",cy:"7",r:"5",key:"d08jfb"}]]);var n=e("MonitorSmartphone",[["path",{d:"M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8",key:"10dyio"}],["path",{d:"M10 19v-3.96 3.15",key:"1irgej"}],["path",{d:"M7 19h5",key:"qswx4l"}],["rect",{width:"6",height:"10",x:"16",y:"12",rx:"2",key:"1egngj"}]]);var p=e("PictureInPicture2",[["path",{d:"M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4",key:"daa4of"}],["rect",{width:"10",height:"7",x:"12",y:"13",rx:"2",key:"1nb8gs"}]]);var m=e("Play",[["polygon",{points:"6 3 20 12 6 21 6 3",key:"1oa8hb"}]]);var L=e("Repeat",[["path",{d:"m17 2 4 4-4 4",key:"nntrym"}],["path",{d:"M3 11v-1a4 4 0 0 1 4-4h14",key:"84bu3i"}],["path",{d:"m7 22-4-4 4-4",key:"1wqhfi"}],["path",{d:"M21 13v1a4 4 0 0 1-4 4H3",key:"1rx37r"}]]);var I=e("Shuffle",[["path",{d:"M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22",key:"1wmou1"}],["path",{d:"m18 2 4 4-4 4",key:"pucp1d"}],["path",{d:"M2 6h1.9c1.5 0 2.9.9 3.6 2.2",key:"10bdb2"}],["path",{d:"M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8",key:"vgxac0"}],["path",{d:"m18 14 4 4-4 4",key:"10pe0f"}]]);var x=e("SkipBack",[["polygon",{points:"19 20 9 12 19 4 19 20",key:"o2sva"}],["line",{x1:"5",x2:"5",y1:"19",y2:"5",key:"1ocqjk"}]]);var C=e("SkipForward",[["polygon",{points:"5 4 15 12 5 20 5 4",key:"16p6eg"}],["line",{x1:"19",x2:"19",y1:"5",y2:"19",key:"futhcm"}]]);var h=e("Volume2",[["path",{d:"M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",key:"uqj9uw"}],["path",{d:"M16 9a5 5 0 0 1 0 6",key:"1q6k2b"}],["path",{d:"M19.364 18.364a9 9 0 0 0 0-12.728",key:"ijwkga"}]]);function v({currentTime:t="0:00",duration:u="0:00",title:o="No track playing",artist:l="No artist",albumArt:r="https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=300&h=300&fit=crop",isPlaying:f=!1,onPlayPause:g=()=>{},onNext:w=()=>{},onPrevious:k=()=>{},onShuffle:P=()=>{},onRepeat:A=()=>{},volume:y=1,onVolumeChange:O=()=>{},progress:R=0,onProgressChange:H=()=>{},"data-id":b}){return a.createElement("div",{className:"flex flex-col bg-black text-gray-300 w-full h-[72px]","data-id":b},a.createElement("div",{className:"flex items-center justify-between px-2 flex-1"},a.createElement("div",{className:"flex items-center space-x-4 min-w-[180px] w-[30%]"},a.createElement("img",{src:r,alt:"",className:"w-14 h-14"}),a.createElement("div",{className:"min-w-0"},a.createElement("h3",{className:"text-white text-sm font-normal truncate hover:underline cursor-pointer"},o),a.createElement("p",{className:"text-xs text-gray-400 truncate hover:underline cursor-pointer"},l)),a.createElement("button",{className:"text-[#1ed760] hover:text-[#1fdf64] transition-colors","aria-label":"Like"},a.createElement(s,{size:16}))),a.createElement("div",{className:"flex flex-col items-center max-w-[722px] w-[40%]"},a.createElement("div",{className:"flex items-center justify-center space-x-4 mb-1"},a.createElement("button",{className:"text-gray-400 hover:text-white transition-colors p-2",onClick:P,"aria-label":"Shuffle"},a.createElement(I,{size:16})),a.createElement("button",{className:"text-gray-400 hover:text-white transition-colors p-2",onClick:k,"aria-label":"Previous track"},a.createElement(x,{size:16})),a.createElement("button",{className:"bg-white text-black rounded-full p-2 hover:scale-105 transition",onClick:g,"aria-label":f?"Pause":"Play"},a.createElement(m,{size:16})),a.createElement("button",{className:"text-gray-400 hover:text-white transition-colors p-2",onClick:w,"aria-label":"Next track"},a.createElement(C,{size:16})),a.createElement("button",{className:"text-[#1ed760] hover:text-[#1fdf64] transition-colors p-2",onClick:A,"aria-label":"Repeat"},a.createElement(L,{size:16}))),a.createElement("div",{className:"flex items-center w-full space-x-2"},a.createElement("span",{className:"text-xs text-gray-400 w-10 text-right"},t),a.createElement("div",{className:"flex-1 h-1 group"},a.createElement("div",{className:"relative h-1 bg-[#4d4d4d] rounded-full"},a.createElement("div",{className:"absolute h-1 bg-white group-hover:bg-[#1ed760] rounded-full",style:{width:`${R}%`}}))),a.createElement("span",{className:"text-xs text-gray-400 w-10"},u))),a.createElement("div",{className:"flex items-center justify-end space-x-2 min-w-[180px] w-[30%] pr-2"},a.createElement("button",{className:"text-gray-400 hover:text-white transition-colors p-2","aria-label":"Lyrics"},a.createElement(d,{size:16})),a.createElement("button",{className:"text-gray-400 hover:text-white transition-colors p-2","aria-label":"Queue"},a.createElement(i,{size:16})),a.createElement("button",{className:"text-gray-400 hover:text-white transition-colors p-2","aria-label":"Connect to device"},a.createElement(n,{size:16})),a.createElement("div",{className:"flex items-center group"},a.createElement("button",{className:"text-gray-400 group-hover:text-white transition-colors p-2","aria-label":"Volume"},a.createElement(h,{size:16})),a.createElement("div",{className:"w-[93px] h-1"},a.createElement("div",{className:"relative h-1 bg-[#4d4d4d] rounded-full"},a.createElement("div",{className:"absolute h-1 bg-white group-hover:bg-[#1ed760] rounded-full",style:{width:`${y*100}%`}})))),a.createElement("button",{className:"text-gray-400 hover:text-white transition-colors p-2","aria-label":"Picture in Picture"},a.createElement(p,{size:16})),a.createElement("button",{className:"text-gray-400 hover:text-white transition-colors p-2","aria-label":"Full screen"},a.createElement(c,{size:16})))))}export{v as MediaPlayer};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/heart.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/list-music.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/maximize-2.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/mic-vocal.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/monitor-smartphone.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/picture-in-picture-2.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/play.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/repeat.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/shuffle.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/skip-back.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/skip-forward.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/volume-2.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
//# sourceMappingURL=index.js.map
